export default customElements.define('w-investment-diamond-v2', class InvestmentDiamondV2 extends wealthify.CustomElementBaseClass {
    constructor() {
        const styleSelector = 'c-investment-diamond-v2';
        const config = {
            styleSelector,
            templateHTML: `
            <div class="${styleSelector}__container" data-root>
                <div class="${styleSelector}__small-diamond ${styleSelector}__small-diamond-lower" data-lowerdiamond>
                    <div class="${styleSelector}__content">      
                        <p class="${styleSelector}__content-projected-title-small">If markets perform worse</p>
                        <p class="${styleSelector}__content-projected-value-small" data-projectedlower></p>
                    </div>    
                </div>
                
                <w-loading-spinner absolute="true" colour="black" data-loadingspinner></w-loading-spinner>

                <div class="${styleSelector}__main-diamond ${styleSelector}__main-diamond-valid" aria-hidden="true" data-maindiamondvalid>
                    <div class="${styleSelector}__content" data-validcontent>
                        <p class="${styleSelector}__content-initial-title" data-initialtitle></p>
                        <p class="${styleSelector}__content-initial-value" data-initialinvestment></p>
                        <p class="${styleSelector}__content-tax-relief" data-taxrelief></p>
                        <p class="${styleSelector}__content-projected-title" data-projectedtitle></p>
                        <p class="${styleSelector}__content-projected-value" data-projected></p>
                        <p class="${styleSelector}__content-projected-footer" data-projectedfooter></p>
                    </div>
                </div>

                <div class="${styleSelector}__main-diamond ${styleSelector}__main-diamond-invalid u-display__none" aria-hidden="true" data-maindiamondinvalid>
                    <div class="${styleSelector}__content" data-contributioncontent>
                        <p class="${styleSelector}__content-contribution-title" data-contributiontitle></p>
                        <p class="${styleSelector}__content-contribution-value u-margin__bottom-mobile--0"> 
                            <span class="${styleSelector}__content-contribution-warning" data-contributionwarning></span>
                            <span class="${styleSelector}__content-contribution-value" data-contributionlimit></span>
                        </p>
                    </div>
                    <div class="${styleSelector}__content" data-basecontent>
                        <span class="${styleSelector}__content-min-contribution-value" data-basemessage></span>
                    </div>
                </div>

                <div class="${styleSelector}__main-diamond ${styleSelector}__main-diamond-inactive u-display__none" aria-hidden="true" data-maindiamondinactive>
                    <div class="${styleSelector}__content" data-inactivecontent>
                        <span class="${styleSelector}__content-inactive-message" data-inactivemessage></span>
                    </div>
                </div>

                <div class="${styleSelector}__small-diamond ${styleSelector}__small-diamond-upper" data-upperdiamond>
                    <div class="${styleSelector}__content">      
                        <p class="${styleSelector}__content-projected-title-small">If markets perform better</p>
                        <p class="${styleSelector}__content-projected-value-small" data-projectedupper></p>
                    </div>    
                </div>

                <div class="u-display__hidden" aria-live="polite" data-arialive></div>
            </div>`,
            cacheDom: [ 
                'data-validcontent',
                'data-initialinvestment', 
                'data-loadingspinner', 
                'data-projected', 
                'data-projectedfooter', 
                'data-taxrelief',
                'data-arialive', 
                'data-lowerdiamond', 
                'data-upperdiamond', 
                'data-maindiamondvalid',
                'data-maindiamondinactive',
                'data-maindiamondinvalid',
                'data-projectedlower',
                'data-projectedupper',
                'data-initialtitle', 
                'data-projectedtitle',
                'data-inactivecontent',
                'data-inactivemessage',
                'data-contributioncontent',
                'data-contributionlimit',
                'data-contributiontitle',
                'data-contributionwarning'
            ],
            hasChildren: true
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
            
            //this._calculateDiamondSize();
            const showInvalidDiamond = this.displayinactivestate || this._exceedsMaxAllowance() || this._belowMinContribution();

            this._toggleDiamonds(showInvalidDiamond);
            this._configureMutationObserver();
        };
    }

    static get validMainDiamondColours() {
        return [
            'blue',
            'green'
        ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('includetaxrelief', {default: false}),

            new wealthify.Prop('includerangeprojections', {default: false}),

            new wealthify.Prop('initialinvestmentvalue', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('initialtitle', { default: 'You Invest' }),

            new wealthify.Prop('label', {required: true}),

            new wealthify.Prop('loading', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('offsettop', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('lowerprojectedvalue', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('projectedvalue', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('projectedfooter'),

            new wealthify.Prop('projectedtitle', { default: 'Projected Value' }),

            new wealthify.Prop('upperprojectedvalue', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('size'),

            new wealthify.Prop('taxreliefvalue', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),

            new wealthify.Prop('totalinvestmentvalue', {
                type: wealthify.propTypes.Number(),
                default: 0
            }),

            new wealthify.Prop('maxvalue', {
                type: wealthify.propTypes.Number(),
                nullable: true
            }),

            new wealthify.Prop('minvalue', {
                type: wealthify.propTypes.Number(),
                nullable: true
            }),

            new wealthify.Prop('monthlyinvestmentvalue', {
                type: wealthify.propTypes.Number(),
                default: 0
            }),

            new wealthify.Prop('maindiamondcolour', {
                default: 'blue',
                type: wealthify.propTypes.ArrayItem(this.validMainDiamondColours)
            }),

            new wealthify.Prop('displayinactivestate', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),

            new wealthify.Prop('inactivemessage')
        ];
    }

    get propCallbacks() {
        return {
            includetaxrelief: (value) => {
                const classListAction = value ? 'remove' : 'add';

                this.dom.taxrelief.classList[classListAction]('u-display__none');
            },

            includerangeprojections: (value) => {
                const classListAction = value ? 'remove' : 'add';

                this.dom.lowerdiamond.classList[classListAction]('u-display__none');
                this.dom.upperdiamond.classList[classListAction]('u-display__none');

                if (this.size === undefined || this.size < 200) {
                    this.size = 250;
                }

                this._calculateDiamondSize();
            },

            initialinvestmentvalue: (value) => {
                if (this.initialinvestmentvalue !== undefined && this.initialinvestmentvalue > 0) {
                    this.totalinvestmentvalue = value;

                    const exceedsMax = this._exceedsMaxAllowance();
                    const belowMin = this._belowMinContribution();
                    const valid = exceedsMax || belowMin;

                    this._toggleDiamonds(valid);
                }
            },

            monthlyinvestmentvalue: () => {
                if(this.monthlyinvestmentvalue !== undefined && this.monthlyinvestmentvalue > 0){
                    const exceedsMax = this._exceedsMaxAllowance();
                    const belowMin = this._belowMinContribution();
                    const valid = exceedsMax || belowMin;
                    
                    this._toggleDiamonds(valid);
                }
            },
            
            totalinvestmentvalue: (value) => {
                this.dom.initialinvestment.innerHTML = wealthify.type.number.toCurrency(value);
            },

            initialtitle: (value) => {
                this.dom.initialtitle.innerHTML = value;
            },

            label: (value) => this.setAttribute('aria-label', value),

            loading: (loading) => {
                this._toggleLoadingSpinner(loading);
            },

            offsettop: () => {
                this._calculateDiamondSize();
            },

            projectedfooter: (value) => {
                this.dom.projectedfooter.innerHTML = value;
            },

            projectedtitle: (value) => {
                this.dom.projectedtitle.innerHTML = value;
            },

            lowerprojectedvalue: (value) => {
                if (this.includerangeprojections) {
                    const projectValueFormatted = wealthify.type.number.toCurrency(value);

                    this.dom.projectedlower.innerHTML = projectValueFormatted;
                    this.dom.arialive.textContent = `Lower projected value is ${projectValueFormatted} ${this.dom.projectedlower.innerHTML}`;
                }
            },

            projectedvalue: (value) => {
                const projectValueFormatted = wealthify.type.number.toCurrency(value);

                this.dom.projected.innerHTML = projectValueFormatted;
                this.dom.arialive.textContent = `Projected value is ${projectValueFormatted} ${this.dom.projectedfooter.innerHTML}`;
            },

            upperprojectedvalue: (value) => {
                if (this.includerangeprojections) {
                    const projectValueFormatted = wealthify.type.number.toCurrency(value);

                    this.dom.projectedupper.innerHTML = projectValueFormatted;
                    this.dom.arialive.textContent = `Upper projected value is ${projectValueFormatted} ${this.dom.projectedupper.innerHTML}`;
                }
            },

            size: () => {
                this._calculateDiamondSize();
            },

            taxreliefvalue: (value) => {
                this.dom.taxrelief.innerHTML = `Plus ${wealthify.type.number.toCurrency(value)} tax relief`;
            },

            maxvalue: () => {
                const exceedsMax = this._exceedsMaxAllowance();

                this._toggleDiamonds(exceedsMax);
            },
            
            minvalue: () => {
                const belowMin = this._belowMinContribution();

                this._toggleDiamonds(belowMin);
            },

            maindiamondcolour: () => {
                this.constructor.validMainDiamondColours.forEach((type) => {
                    this.dom.maindiamondvalid.classList.remove(`${this.styleSelector}__main-diamond-valid--${type}`);
                });
                this.dom.maindiamondvalid.classList.add(`${this.styleSelector}__main-diamond-valid--${this.maindiamondcolour}`);
            }, 

            displayinactivestate: () => {
                this._toggleDiamonds(this.displayinactivestate);
            },

            inactivemessage: () => {
                this.dom.inactivemessage.innerHTML = this.inactivemessage;
            },
        };
    }

    // monitor when text fields are modified in the target node's subtree
    _configureMutationObserver() {
        const targetNode = this.dom.validcontent;

        // modifying content of element destroys and creates new text node, so listen for changes to the childlist
        const options = {
            childList: true,
            subtree: true
        };
        
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type == 'childList') {
                    this._calculateDiamondSize();
                }
            });
        });

        observer.observe(targetNode, options);
    }

    _calculateDiamondSize() {
        const contentLength = this.dom.validcontent.offsetHeight > this.dom.validcontent.offsetWidth ? this.dom.validcontent.offsetHeight : this.dom.validcontent.offsetWidth;
        const diamondLength = this.size !== undefined && this.size >= contentLength ? this.size : contentLength + 40;

        this.dom.maindiamondvalid.style.width = `${diamondLength}px`;
        this.dom.maindiamondvalid.style.height = `${diamondLength}px`;

        this.dom.maindiamondinvalid.style.width = `${diamondLength}px`;
        this.dom.maindiamondinvalid.style.height = `${diamondLength}px`;

        this.dom.maindiamondinactive.style.width = `${diamondLength}px`;
        this.dom.maindiamondinactive.style.height = `${diamondLength}px`;

        // used to calculate the cross section of the diamond(s) height and width to correctly size the component
        let hypotenuseHeight, hypotenuseWidth;

        if (this.includerangeprojections && !this._exceedsMaxAllowance() && !this._belowMinContribution()) {
            // size the smaller diamonds relative to the main diamond
            const smallDiamondLength = diamondLength / 2;
            
            this.dom.lowerdiamond.style.height = `${smallDiamondLength}px`;
            this.dom.lowerdiamond.style.width = `${smallDiamondLength}px`;
            this.dom.upperdiamond.style.height = `${smallDiamondLength}px`;
            this.dom.upperdiamond.style.width = `${smallDiamondLength}px`;
        
            // a small diamond extends the component width by half its cross section
            // there are 2 diamonds so calculate cross section of 1 whole
            const hypotenuseSmall = Math.hypot(smallDiamondLength, smallDiamondLength);

            // calculate hypotenuse as normal but factor in small diamonds
            hypotenuseWidth = Math.hypot(diamondLength, diamondLength) + hypotenuseSmall;
            hypotenuseHeight = Math.hypot(diamondLength, diamondLength);

        // singular diamond, same width and height
        } else {
            hypotenuseHeight = hypotenuseWidth = Math.hypot(diamondLength, diamondLength);
        }

        this.style.width = `${hypotenuseWidth}px`;
        this.style.height = `${hypotenuseHeight}px`;

        if (this.offsettop) {
            this._setOffset(hypotenuseHeight);
        }
    }

    _setOffset(hypotenuse) {
        this.style.position = 'absolute';
        this.style.top = `-${hypotenuse / 2 }px`;
        this.parentElement.style.marginTop = `${hypotenuse / 2}px`;
    }

    _exceedsMaxAllowance(){
        const initialinvestmentInvalid = (this.maxvalue === undefined || this.initialinvestmentvalue === undefined || this.initialinvestmentvalue === 0) ? false : this.initialinvestmentvalue > this.maxvalue;
        const monthlyInvestmentInvalid = (this.maxvalue === undefined || this.monthlyinvestmentvalue === undefined || this.monthlyinvestmentvalue === 0) ? false : this.monthlyinvestmentvalue > this.maxvalue;

        return initialinvestmentInvalid || monthlyInvestmentInvalid;
    }

    _belowMinContribution(){
        const initialinvestmentInvalid = (this.minvalue === undefined || this.initialinvestmentvalue === undefined || this.initialinvestmentvalue === 0) ? false : this.initialinvestmentvalue < this.minvalue;
        const monthlyInvestmentInvalid = (this.minvalue === undefined || this.monthlyinvestmentvalue === undefined || this.monthlyinvestmentvalue === 0) ? false : this.monthlyinvestmentvalue < this.minvalue;

        return initialinvestmentInvalid || monthlyInvestmentInvalid;
    }

    _toggleDiamonds(showInvalidDiamond) {
        const validClassListAction = showInvalidDiamond ? 'add' : 'remove';
        const inactiveDiamondClassListAction = this.displayinactivestate ? 'remove' : 'add';
        const invalidClassListAction = showInvalidDiamond && !this.displayinactivestate ? 'remove' : 'add';

        this.dom.maindiamondvalid.classList[validClassListAction]('u-display__none');
        this.dom.maindiamondinactive.classList[inactiveDiamondClassListAction]('u-display__none');
        this.dom.maindiamondinvalid.classList[invalidClassListAction]('u-display__none');

        this._toggleContributionWarningText();
        this._toggleProjectionDiamonds(!showInvalidDiamond);

        this._calculateDiamondSize();
    }

    _toggleLoadingSpinner(show) {
        const spinnerClassListAction = show ? 'remove' : 'add';
        const contentClassListAction = show ? 'add' : 'remove';

        this.dom.loadingspinner.classList[spinnerClassListAction]('u-display__none');
        this.dom.validcontent.classList[contentClassListAction](`${this.styleSelector}--hidden`);

        this._toggleProjectionDiamonds(!show);
    }

    _toggleProjectionDiamonds(show) {
        if (this.includerangeprojections) {
            const classListAction = show ? 'remove' : 'add';

            this.dom.lowerdiamond.classList[classListAction]('u-display__none');
            this.dom.upperdiamond.classList[classListAction]('u-display__none');
        }
    }

    _toggleContributionWarningText(){
        const exceedsMax = this._exceedsMaxAllowance();
        const belowMin = this._belowMinContribution();

        if (exceedsMax) {
            this.dom.contributiontitle.innerHTML = 'Reduce your <br> contribution';
            this.dom.contributionwarning.innerHTML = 'You can <br> contribute up <br> to';
            this.dom.contributionlimit.innerHTML = wealthify.type.number.toCurrency(this.maxvalue);
        } else if (belowMin) {
            this.dom.contributiontitle.innerHTML = 'Increase your <br> contribution';
            this.dom.contributionwarning.innerHTML = 'You need <br> to add at <br> least';
            this.dom.contributionlimit.innerHTML = wealthify.type.number.toCurrency(this.minvalue);
        } else {
            this.dom.contributiontitle.innerHTML = '';
            this.dom.contributionwarning.innerHTML = '';
            this.dom.contributionlimit.innerHTML = '';
        }
    }
});